<template>
  <div class="d-flex duration-container">
    <div class="d-flex flex-column" v-if="years">
      <label class="control-label">Years
        <input class="form-control" :class="yearClass" type="number" min="0" v-model="values.years" name="years" @change="onChange"/>
      </label>
    </div>
    
    <div class="d-flex flex-column" v-if="months">
      <label class="control-label">Months
        <input class="form-control" :class="monthClass" type="number" min="0" v-model="values.months" name="months" @change="onChange"/>
      </label>
    </div>

    <div class="d-flex flex-column" v-if="weeks">
      <label class="control-label">Weeks
        <input class="form-control" type="number" min="0" v-model="values.weeks" name="weeks" @change="onChange"/>
      </label>
    </div>

    <div class="d-flex flex-column" v-if="days">
      <label class="control-label">Days
        <input class="form-control" :class="dayClass" type="number" min="0" v-model="values.days" name="days" @change="onChange"/>
      </label>
    </div>

    <div class="d-flex flex-column" v-if="hours">
      <label class="control-label">Hours
        <input class="form-control" :class="hourClass" type="number" min="0" v-model="values.hours" name="hours" @change="onChange"/>
      </label>
    </div>

    <div class="d-flex flex-column" v-if="minutes">
      <label class="control-label">Minutes
        <input class="form-control" :class="minuteClass" type="number" min="0" v-model="values.minutes" name="minutes" @change="onChange"/>
      </label>
    </div>

    <div class="d-flex flex-column" v-if="seconds">
      <label class="control-label">Seconds
        <input class="form-control" :class="secondClass" type="number" min="0" v-model="values.seconds" name="seconds" @change="onChange"/>
      </label>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'DurationInput',

  props: {
    value: {},

    years: {
      type: Boolean,
      default: true,
    },

    months: {
      type: Boolean,
      default: true,
    },

    weeks: {
      type: Boolean,
      default: false,
    },

    days: {
      type: Boolean,
      default: true,
    },

    hours: {
      type: Boolean,
      default: true,
    },

    minutes: {
      type: Boolean,
      default: true,
    },

    seconds: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    const duration = moment.duration(this.value * 1000);

    return {
      duration: duration,

      values: {
        years:   duration.years(),
        months:  duration.months(),
        weeks:   0,
        days:    duration.days(),
        hours:   duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      },
    };
  },
  
  computed: {
    /** @returns {Object} */
    yearClass() {
      return {
        muted: this.values.years === 0,
      };
    },

    /** @returns {Object} */
    monthClass() {
      return {
        muted: this.values.months === 0,
      };
    },

    /** @returns {Object} */
    dayClass() {
      return {
        muted: this.values.days === 0,
      };
    },

    /** @returns {Object} */
    hourClass() {
      return {
        muted: this.values.hours === 0,
      };
    },

    /** @returns {Object} */
    minuteClass() {
      return {
        muted: this.values.minutes === 0,
      };
    },

    /** @returns {Object} */
    secondClass() {
      return {
        muted: this.values.seconds === 0,
      };
    },
  },

  watch: {
    value(newValue) {
      const duration = moment.duration(newValue, 'seconds');
      this.resetValues(duration);
    },

    duration(newValue) {
      const seconds = newValue.asSeconds();
      this.$emit('input', seconds);
    },
  },

  methods: {
    resetValues(duration) {
      this.values = {
        years:   duration.years(),
        months:  duration.months(),
        weeks:   0,
        days:    duration.days(),
        hours:   duration.hours(),
        minutes: duration.minutes(),
        seconds: duration.seconds(),
      };
    },

    onChange(evt) {
      const value = Number(evt.target.value);
      const name = evt.target.name;

      this.duration = moment.duration({
        ...this.values,
        [name] : value,
      });      
    },
  },
};
</script>

<style scoped>
.duration-container {
  gap: 1em;
}

.muted,
.muted:focus {
  color: #dcdcdc;
}
</style>
